<template>
  <span v-if="isColoredIcon" :class="[classes, `icon-${name}`]" :style="styles">
    <template v-for="num in numOfPaths"><span :key="num" :class="`path${num}`"></span> </template>
  </span>
  <i v-else :class="classes" :style="styles" :aria-hidden="ariaHidden" @click="$emit('click', $event)">{{ name }}</i>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import DomContentLoadedMixin from 'vuemixins/dom_content_loaded_mixin'
/* type NumberOfPaths = number */
const COLORED_ICONS /*: Record<string, NumberOfPaths> */ = {
  'amazon-color': 2,
  'paypal-color': 3,
  'discover-color': 3,
  'jcb-color': 5,
  'mastercard-color': 3,
  'unionpay-color': 5,
  'amex-color': 2,
  'dinersclub-color': 3,
  'visa-color': 3,
}
export default {
  mixins: [DomContentLoadedMixin],
  props: {
    name: {
      type: String,
      required: true,
      validator: (name) => !!name,
    },
    size: {
      type: [String, Number],
      required: false,
      default: 'normal',
      validator: (value) => typeof value == 'number' || ['small', 'normal', 'large'].includes(value),
    },
    ariaHidden: {
      type: String,
      required: false,
      default: 'true',
      validator: (value) => ['true', 'false'].includes(value),
    },
  },
  computed: {
    isColoredIcon() {
      return Object.keys(COLORED_ICONS).includes(this.name)
    },
    numOfPaths() {
      return COLORED_ICONS[this.name]
    },
    classes() {
      const classList = []
      if (this.isDomLoaded) {
        classList.push('immaterial-icons')
        if (this.size === 'small') {
          classList.push('immaterial-icons-18')
        }
        if (this.size === 'large') {
          classList.push('immaterial-icons-32')
        }
      } else {
        classList.push('immaterial-placeholder')
        if (this.size === 'small') {
          classList.push('immaterial-placeholder-18')
        }
        if (this.size === 'large') {
          classList.push('immaterial-placeholder-32')
        }
      }
      return classList
    },
    styles() {
      if (typeof this.size == 'number') {
        if (this.isDomLoaded) {
          return `font-size: ${this.size}px; max-width:${this.size}px; width: ${this.size}px; height: ${this.size}px; overflow: visible;`
        } else {
          return `max-width:${this.size}px; width: ${this.size}px; height: ${this.size}px;`
        }
      }
      return ''
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/3/partials/fonts/material_icons';

.immaterial-icons {
  @include immaterial-icon;
}

.immaterial-icons-18 {
  font-size: 18px;
}

.immaterial-icons-32 {
  font-size: 32px;
  padding: 5px;
}

.immaterial-placeholder {
  visibility: hidden;
  width: 24px;
  height: 24px;
  display: inline-block;
}

.immaterial-placeholder-18 {
  visibility: hidden;
  width: 18px;
  height: 18px;
  display: inline-block;
}

.immaterial-placeholder-32 {
  visibility: hidden;
  width: 32px;
  height: 32px;
  padding: 5px;
  display: inline-block;
}
</style>
